<template>
  <div class="test-container">
    <div class="div">Test1</div>
    <router-link to="/">
      <div style="display:inline-block;background:#eee;width:200px;height:100px;">Home</div>
    </router-link>
    <router-link to="/test">
      <img style="width:200px" src="../../common/images/c.jpg" />
    </router-link>
    <router-link to="/test1">
      <img style="width:200px" src="../../common/images/c.jpg" />
    </router-link>
    <router-link to="/test2">
      <img style="width:200px" src="../../common/images/c.jpg" />
    </router-link>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  data() {
    return {
      pagination: {
        page: 1,
        size: 10,
        total: 0
      },
      list: [],
      isListPage: "",
      navIndex: 0
    };
  },

  computed: {},

  created() {
    console.log("created");
  },

  methods: {},

  components: {}
};
</script>

<style lang="less" rel="stylesheet/less" scoped="true">
@import url("../../common/less/variable.less");

.test-container {
  width: 100%;
  height: 100%;
  background: blue;
  .div {
    width: 500px;
    text-align: center;
    height: 200px;
    line-height: 200px;
  }
}
</style>
